import axios from "axios";
import { getBusinessRules } from "../../../../../../services/business-rules";
import {
  getCalculation,
  getDiaryPage,
  getPatientAttributeConfiguration,
  getQuestionaireId,
  getQuestionaireType,
  getSubmitActionParameters,
} from "../../../../../../services/calculation";
import {
  calcServer,
  DeleteQuestionById,
} from "../../../../../../services/questionaireBuilder";

export const getDiaryPageData = async (questionId) => {
  try {
    const res = await getDiaryPage(questionId);
    return res;
  } catch (err) {
    console.log("Error: ", err.message);
  }
};

export const getAllQuestionDataService = async () => {
  try {
    const res = await getQuestionaireId();
    return res;
  } catch (err) {
    console.log("Error: ", err.message);
  }
};

export const getPatientAttributeConfigurationDataService = async () => {
  try {
    const res = await getPatientAttributeConfiguration();
    return res;
  } catch (err) {
    console.log("Error: ", err.message);
  }
};

export const getSubmitActionParametersDataService = async (questionnaireId) => {
  try {
    const res = await getSubmitActionParameters(questionnaireId);
    return res;
  } catch (err) {
    console.log("Error: ", err.message);
  }
};

export const getQuestionaireTypeDataServide = async (questionnaireId) => {
  try {
    const res = await getQuestionaireType(questionnaireId);
    return res;
  } catch (err) {
    console.log("Error: ", err.message);
  }
};

export const getBusinessRulesDataService = async () => {
  try {
    const res = await getBusinessRules();
    return res;
  } catch (err) {
    console.log("Error: ", err.message);
  }
};

export const getCalculationDataService = async () => {
  try {
    const res = await getCalculation();
    return res;
  } catch (err) {
    console.log("Error: ", err.message);
  }
};

export const createQuestion = async (data) => {
  const config = {
    method: "post",
    url: `${process.env.REACT_APP_IDENTITY_URL}/app/Question/CreateQuestion`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  };

  try {
    const response = await axios(config);
    console.log("API Response: ", response.data);
    return response;
  } catch (error) {
    console.error("API Error: ", error);
    throw error;
  }
};

export const getQuestionnaireByIdService = (questionnaireId) => {
  return new Promise((resolve, reject) => {
    calcServer
      .get(`app/Question/GetQuestionList?QuestionnaireId=${questionnaireId}`)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

export const updateQuestionnaireService = async (payload) => {
  const config = {
    method: "post",
    url: `${process.env.REACT_APP_IDENTITY_URL}/app/Question/api/SaveEditedData`,
    headers: {
      "Content-Type": "application/json",
    },
    data: payload,
  };

  try {
    const response = await axios(config);
    return response;
  } catch (error) {
    console.error("API Error: ", error);
    throw error;
  }
};

export const deleteAllQuestionService = (questionnaireId) => {
  return new Promise((resolve, reject) => {
    calcServer
      .get(
        `app/Question/DeleteQuestionsByQuestionnaireId?QuestionnaireId=${questionnaireId}`,
      )
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};
